<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>XOML</mat-label>
  <textarea matInput [rows]="10" [(ngModel)]="originalActivity"></textarea>
</mat-form-field>
